import { TourType } from '@/types/tour';
import type { TourConfig } from './types';

export const tourConfig: TourConfig = {
  [TourType.APP_LANDING_FIRST_VISIT]: {
    id: TourType.APP_LANDING_FIRST_VISIT,
    name: 'App Landing First Visit',
    required: true,
    autoStart: true,
    steps: [
      {
        id: 'upload-files',
        target: '#upload-button',
        title: 'Add files or folders',
        content:
          'Upload files or folders here. We support all popular document, audio and video filetypes.',
        placement: 'bottom',
        targetAnchorPosition: 0.78,
        tooltipAnchorPosition: 0.1,
        tooltipOffset: {
          y: 6,
        },
      },
      {
        id: 'create-folders',
        target: '#create-button',
        title: 'Create folders',
        content:
          'Click the "+" icon to create a folder. Drag and drop folders to nest them as subfolders.',
        placement: 'right',
        targetAnchorPosition: 0.5,
        tooltipAnchorPosition: 0.13,
        tooltipOffset: {
          x: 6,
          y: 0,
        },
      },
      {
        id: 'open-folder',
        target: '#open-folder',
        title: 'Open folder',
        content:
          'Select a folder to explore and chat with its contents - including files in nested subfolders.',
        placement: 'right',
        targetAnchorPosition: 0,
        tooltipAnchorPosition: 0.14,
        tooltipOffset: {
          x: 6,
        },
      },
    ],
  },
  [TourType.CHAT_FIRST_VISIT]: {
    id: TourType.CHAT_FIRST_VISIT,
    name: 'Chatbot Features',
    required: false,
    autoStart: false,
    steps: [
      {
        id: 'previous-chats',
        target: '#previous-chats',
        title: 'Previous chats',
        content:
          'View previous conversations with this file or folder. Click to reopen any chat and pick up where you left off.',
        placement: 'bottom',
        targetAnchorPosition: 0.1,
        tooltipAnchorPosition: 0.1,
        tooltipOffset: {
          y: 6,
          x: 0,
        },
      },
      {
        id: 'right-sidebar',
        target: '#right-sidebar',
        title: 'Right sidebar',
        content:
          'Access citation details, find related papers and review annotations here.',
        placement: 'bottom',
        targetAnchorPosition: 0.4,
        tooltipAnchorPosition: 0.7,
        tooltipOffset: {
          y: 1,
          x: -30,
        },
      },
    ],
  },
  [TourType.LIBRARY_FIRST_VISIT]: {
    id: TourType.LIBRARY_FIRST_VISIT,
    name: 'Library First Visit',
    required: true,
    autoStart: true,
    steps: [
      {
        id: 'chatbot-settings',
        target: '#chatbot-button',
        title: 'Chat',
        content:
          'Chat with the folder or file in view to quickly find and simplify information.',
        placement: 'bottom',
        targetAnchorPosition: 0.2,
        tooltipAnchorPosition: 0.8,
        tooltipOffset: {
          y: 3,
          x: -30,
        },
      },
    ],
  },
};
